import actions from '../constants';

export default (state = 1, action) => {
  switch (action.type) {
    case actions.SET_PERIOD:
      return action.payload.period;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/coding/reducers/period.js